// https://res.cloudinary.com/<cloud_name>/<asset_type>/<delivery_type>/<transformations>/<version>/<public_id_full_path>.<extension>

export type RemoteMediaOptions = {
  width?: number | "auto"
  height?: number | "auto"
  format?: string | "auto" // e.g., "jpg", "png", "webp" | "auto"
}

export const getRemoteMedia = (name: string, options?: RemoteMediaOptions) => {
  const cloudName = "diij4p2ms"
  const assetType = "image"
  const deliveryType = "upload"
  const transformations: string[] = []
  if (options?.width) {
    transformations.push(`w_${options.width}`)
  }
  if (options?.height) {
    transformations.push(`h_${options.height}`)
  }
  if (options?.format) {
    transformations.push(`f_${options.format}`)
  }

  return `https://res.cloudinary.com/${cloudName}/${assetType}/${deliveryType}/${transformations.join(
    ","
  )}/${name}`
}
